"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getI18nSupportedModuleEntries = exports.extractI18nPropertiesFromModules = exports.extractI18nKeysFromModules = exports.getTranslationValue = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./constants"), exports);
tslib_1.__exportStar(require("./translationsGetter"), exports);
tslib_1.__exportStar(require("./translator"), exports);
tslib_1.__exportStar(require("./ensureLocale"), exports);
var translationValueGetter_1 = require("./translationValueGetter");
Object.defineProperty(exports, "getTranslationValue", { enumerable: true, get: function () { return translationValueGetter_1.getTranslationValue; } });
var moduleI18nHelper_1 = require("./moduleI18nHelper");
Object.defineProperty(exports, "extractI18nKeysFromModules", { enumerable: true, get: function () { return moduleI18nHelper_1.extractI18nKeysFromModules; } });
Object.defineProperty(exports, "extractI18nPropertiesFromModules", { enumerable: true, get: function () { return moduleI18nHelper_1.extractI18nPropertiesFromModules; } });
Object.defineProperty(exports, "getI18nSupportedModuleEntries", { enumerable: true, get: function () { return moduleI18nHelper_1.getI18nSupportedModuleEntries; } });
tslib_1.__exportStar(require("./types"), exports);
